import { Button, Flex } from "@chakra-ui/react";
import { FormProvider, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { SignupError } from "../../../common/redux/thunks/auth/signup-as-person-thunk";
import { ConsentCheckboxes, ConsentFieldValues } from "../shared/ConsentCheckboxes";
import { OwnerIdentityFields, OwnerIdentityFieldValues } from "../shared/OwnerIdentityFields";
import { useSignupError } from "../shared/useSignupError";

export type RegisterOrgOwnerFormValues = OwnerIdentityFieldValues & ConsentFieldValues;

interface Props {
  isSubmitting: boolean;
  signupError?: SignupError | string | null;
  onSubmit: (values: RegisterOrgOwnerFormValues) => Promise<void> | void;
}

export const RegisterOrgOwnerForm = ({ isSubmitting, signupError, onSubmit }: Props) => {
  const { t } = useTranslation();
  const methods = useForm<RegisterOrgOwnerFormValues>();

  useSignupError(signupError, methods);

  return (
    <FormProvider {...methods}>
      <form onSubmit={methods.handleSubmit(onSubmit)}>
        <OwnerIdentityFields />
        <ConsentCheckboxes />
        <Flex mt="20px" justifyContent="end">
          <Button type="submit" colorScheme="teal" isLoading={isSubmitting}>
            {t("Sign up")}
          </Button>
        </Flex>
      </form>
    </FormProvider>
  );
};
